export default __webpack_public_path__ + "static/media/omni.60a053c4.png";